// <div data-controller="components--form">
//
// </div>
import { Controller } from "stimulus";
import api from "utils/api";

// https://stimulus.hotwired.dev/reference
export default class extends Controller {
  static targets = [ "form" ];
  static classes = [ "" ];
  static values = {};

  onSelectSubmit(e) {
    this.formTarget.submit();
  }

  connect() {

  }

  disconnect() {

  }
}